import { render } from "./SerieItems.vue?vue&type=template&id=44a7fa6c"
import script from "./SerieItems.vue?vue&type=script&lang=js"
export * from "./SerieItems.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__